import PropTypes from 'prop-types';
import React, { useState, useRef } from 'react';

import DataTable from '../../DataTable/components/DataTable';
import { ToastContainer, toast } from 'react-toastify';
import Popup from "reactjs-popup";
import ArtistPickerField from '../../shared/components/ArtistPickerField';
import { fetchArtistOptions } from '../../shared/components/ArtistSelectComponents';
var ReactDOM = require('react-dom');

const axios = require('axios').default;

import $ from 'jquery';
require('datatables.net-bs4');

const popupContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "245px",
  "padding": "0px"
}

const decodeHtml = (html) => {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

const MyArtists = ({
  csrfToken,
  team,
  currentUser,
  dataTableTitle,
  dataTableDataSource,
  dataTableOrder,
  dataTableColumns,
  artistOwnerships,
  artistOwnershipsChanged
}) => {
  const dataTableElRef = useRef(null);

  const [newArtistModalOpen, setNewArtistModalOpen] = useState(false);

  const createArtistOwnership = (artist) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/artist_ownerships", {
        artist_ownership: {
          artistable_id: artist.id
        }
      })
      .then(({ data }) => {
        var updated = [...artistOwnerships, data];
        artistOwnershipsChanged(updated);

        $(dataTableElRef.current).DataTable().ajax.reload();
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };

  const deleteArtistOwnership = (artistOwnership) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete("/teams/" + team.id + "/artist_ownerships/" + artistOwnership.id)
      .then(({ data }) => {
        var updated = artistOwnerships.filter(ao => ao.id !== artistOwnership.id);
        artistOwnershipsChanged(updated);

        $(dataTableElRef.current).DataTable().ajax.reload();
      });
  };

  const isArtistAlreadyAdded = (artist) => {
    return artistOwnerships.find(
      ao => ao.artistable_id === artist.id && ao.artistable_type === "Artist"
    ) !== undefined;
  };

  // Shared artist search, with roster state layered on: artists the team
  // already owns render disabled with a "My artist" badge.
  const fetchRosterOptions = (query, callback) => {
    fetchArtistOptions(query, (options) => {
      callback((options || []).map((option) => (
        isArtistAlreadyAdded({ id: option.value })
          ? { ...option, disabled: true, badge: 'My artist' }
          : option
      )));
    });
  };

  return (
    <div>
      <ToastContainer icon={false} />
      <div className="datatable-right-header-section"
            style={artistOwnerships.length === 0 ? {top: "-40px"} : {}}>
        <a href="#"
           onClick={(e) => {
             e.preventDefault();
             setNewArtistModalOpen(true);
           }}
           className="btn btn-primary">
          <strong>Add an Artist</strong>
        </a>
      </div>
      {artistOwnerships.length > 0 ? (
        <DataTable title={dataTableTitle}
                  dataSource={dataTableDataSource}
                  columns={dataTableColumns}
                  colGroup={
                    <colgroup>
                      <col span={1} style={{"width": "25%"}} />
                      <col span={1} style={{"width": "70%"}} />
                      <col span={1} style={{"width": "5%"}} />
                    </colgroup>
                  }
                  onTableElementSet={
                    (el) => {
                      dataTableElRef.current = el;
                    }
                  }
                  rowCallback={
                    function(row, data, displayNum, displayIndex, dataIndex){
                      let dataTable = this;
                      let artistOwnership = JSON.parse(decodeHtml(data.json));
                      var mountArtistOwnershipMenuReact = row.getElementsByClassName("my-artists-mount-react")[0];

                      ReactDOM.render((
                        <div>
                          {currentUser.can_manage_posts ? (
                            <Popup arrow={false}
                                    offsetY={5}
                                    position="bottom right"
                                    contentStyle={popupContentStyle}
                                    onOpen={
                                      (e) => {
                                        e.preventDefault();
                                      }
                                    }
                                    trigger={open => (
                                      <a href="#"
                                        className="text-muted">
                                        <i className="fas fa-ellipsis-v"></i>
                                      </a>
                                    )} >
                              {close => (
                                <div className='row text-left'>
                                  <div className="col-12">
                                    <p style={{margin: "15px"}}>
                                      <strong className="text-dark">
                                        Artist menu
                                      </strong>
                                    </p>
                                    <hr className="m-0" />
                                    <ul className="list-group offer-inline-menu highlight-primary">
                                      <li className="list-group-item"
                                          style={{
                                            padding: "15px 15px 12px 15px",
                                            borderTopLeftRadius: "0px",
                                            borderTopRightRadius: "0px",
                                            borderBottomLeftRadius: "8px",
                                            borderBottomRightRadius: "8px"
                                          }}>
                                        <a href="#"
                                            onClick={
                                              (e) => {
                                                e.preventDefault();

                                                if(confirm("Are you sure you want to remove this artist from your team?")) {
                                                  deleteArtistOwnership(artistOwnership);
                                                }
                                              }
                                            }
                                            className="text-dark">
                                          <span className="d-inline-block text-center" style={{width: "28px"}}>
                                            <i className="fas fa-pencil"></i>
                                          </span>
                                          Remove artist
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </Popup>
                          ) : null}
                        </div>
                      ), mountArtistOwnershipMenuReact);
                    }
                  }
                  order={dataTableOrder} />
      ) : (
        <div className="card border-0 shadow-4"
              style={{
                borderRadius: "12px",
                maxWidth: "400px",
                margin: "60px auto 20px auto"
              }}>
          <div className="card-body"
                style={{padding: "25px"}}>
            <div className="mb-4">
              <div className="d-flex justify-content-center align-items-center"
                  style={{
                     borderRadius: "50%",
                     width: "48px",
                     height: "48px",
                     backgroundColor: "#E3F2FD",
                     marginBottom: "20px"
                  }}>
                <i className="far fa-microphone fa-fw"
                    style={{fontSize: "24px", color: "#1976D2"}}></i>
              </div>
            </div>
            <h3 className="mb-2"
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#212529"
                }}>
              Add an artist
            </h3>
            <p className="mb-4"
               style={{
                 fontSize: "14px",
                 color: "#6C757D"
               }}>
              Get started by adding your first artist to your database. You can track their tour status, manage bookings, and keep all your artist information organized in one place.
            </p>
            <a href="#"
               onClick={(e) => {
                 e.preventDefault();
                 setNewArtistModalOpen(true);
               }}
               className="btn btn-primary btn-block"
               style={{
                 fontSize: "16px",
                 fontWeight: "600",
                 padding: "12px 24px"
               }}>
              Add your first artist
            </a>
          </div>
        </div>
      )}
      <ArtistPickerField
        open={newArtistModalOpen}
        onOpenChange={setNewArtistModalOpen}
        teamId={team.id}
        description="Search for an artist to add to your roster, or add a new one inline."
        fetchOptions={fetchRosterOptions}
        onSelect={(sel) => createArtistOwnership({ id: sel.artistId })}
      />
    </div>
  )
};

MyArtists.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  dataTableTitle: PropTypes.string.isRequired,
  dataTableDataSource: PropTypes.string.isRequired,
  dataTableOrder: PropTypes.array,
  dataTableColumns: PropTypes.array.isRequired,
  artistOwnerships: PropTypes.array.isRequired,
  artistOwnershipsChanged: PropTypes.func.isRequired
};

export default MyArtists;
